import LinearGradient from 'react-native-linear-gradient';
import { Surface } from 'react-native-paper';
import SafeAreaView from 'react-native-safe-area-view';
import styled from 'styled-components/native';

import Button from '@src/components/Button';
import GradientTextBase from '@src/components/GradientText';
import Image from '@src/components/Image';
import ImageBackground from '@src/components/ImageBackground';
import { H1, Subtitle1 } from '@src/components/Typography';
import { padding } from '@src/configuration/constants';

export const Container = styled(SafeAreaView).attrs({
  forceInset: { top: 'never' },
})`
  background-color: ${({ theme }) => theme.colors.background};
  flex: 1;
`;

export const Background = styled(ImageBackground)`
  width: 100%;
  height: 100%;
  position: absolute;
  top: -150px;
  left: 0;
  right: 0;
`;

export const Gradient = styled(LinearGradient)`
  height: 100%;
`;

export const GradientText = styled(GradientTextBase).attrs(({ theme }) => ({
  startColor: theme.colors.primary,
  endColor: theme.colors.secondary,
}))`
  margin-vertical: 20px;
`;

export const Logotype = styled(Image).attrs({
  resizeMode: 'contain',
})`
  margin-top: ${padding}px;
  margin-bottom: ${padding - 10}px;
  width: 170px;
  height: 170px;
`;

export const Content = styled.View`
  flex: 1;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 10%;
  position: relative;
`;

export const ContainButton = styled(Button).attrs(({ theme }) => ({
  uppercase: false,
  mode: 'contained',
  labelStyle: {
    color: theme.colors.onPrimary,
  },
}))`
  margin-top: 10px;
  width: 100%;
  align-self: center;
`;

export const TextButton = styled(Button).attrs({
  uppercase: false,
  mode: 'text',
})`
  margin-top: 10px;
  width: 100%;
  align-self: center;
`;

export const CenterContainer = styled(Surface)`
  justify-content: space-evenly;
  align-items: center;
  width: 90%;
  elevation: 4;
  border-radius: ${({ theme }) => theme.containerRoundness}px;
  padding: ${padding}px ${padding}px ${padding * 2}px ${padding}px;
`;

export const LanguageButton = styled(TextButton).attrs(({ theme }) => ({
  icon: 'language',
  theme: { ...theme, roundness: 0 },
}))`
  border-radius: 0;
`;

export const Footer = styled.View``;

export const CenterCaption = styled(Subtitle1)`
  align-self: center;
  text-align: center;
`;

export const Title = styled(H1)`
  align-self: center;
  text-align: center;
  margin-bottom: 10px;
`;
